<template>
  <div class="home-dashboard">
    <h1 class="page-title title">{{ $t("dashboard.label.mypage") }}</h1>
    <div class="page-ct">
      <div class="box-title title clearfix">
        <h4 class="no-margin">{{ $t("dashboard.title.summary") }}</h4>
        <div class="title-action">
          {{ $t("dashboard.title.time") }}:
          <span class="date-time">{{ serverTime }} </span>
          <a class="btn btn-sm btn-warning" @click="reloadPage">
            <i class="fas fa-sync-alt" style="color: white"/>
          </a>
        </div>
      </div>
      <div class="page-meta clearfix">
        <div class="alert alert-danger" v-if="errorMessage">{{$t(errorMessage)}}</div>
        <div class="row">
          <div class="col-md-6">
            <div class="balance">
              <span class="text-bigger">
                <strong>{{ $t("dashboard.label.total_equity") }}</strong>
                <span id="tooltipbig" title="" style="color: #82796d; padding-right: 30px; padding-left: 5px">
                  <i class="fa fa-question-circle" id="dashboard-tooltip"></i>
                  <div class="tooltipbig-wrapper">
                    {{ $t("trs.transfer.lable.tooltip.sc.public") }}
                  </div>
                </span>
                <strong class="number" style="white-space: nowrap">{{ totalEquity | moneyFormat }}
                  <span class="yen">{{ $t("currency.japanese.yen") }}</span>
                </strong>
              </span>
            </div>
          </div>
          <div class="col-md-6">
            <div class="meta-bot">
              <div class="meta-action">
                <router-link to="deposit" class="btn btn-success btn-padding-lg" style="margin-left: 5px">
                  {{ $t("trs.front.title.left.menu.deposit") }}
                </router-link>
                <router-link to="transfer" class="btn btn-primary btn-padding-lg" style="margin-left: 5px">
                  {{ $t("trs.front.title.left.menu.transfer") }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="overview section">
        <div class="row row-narrow">
          <div class="col-md-4" v-for="item in activeServicesHasSigleBlock" :key="item.id">
            <div class="box" v-for="balance in item.balanceBlock" :key="balance.title">
              <h5 class="box-title title no-border">{{ $t(balance.title) }}
                <span v-if="item.isMaintenance" id="tooltip-maintain" style="color: #82796d; padding-right: 30px; padding-left: 5px">
                  <i class="fa fa-exclamation-triangle text-warning" />
                  <div class="tooltipbig-wrapper">
                    {{ $t('MSG_TRS_NAF_0192', {param0 : $t(balance.frontHeaderTitle)} ) }}
                  </div>
                </span>
              </h5>
              <div class="box-ct">
                <table class="table table-noborder table-striped balance-table">
                  <tbody>
                  <tr v-for="(value, name) in balance.fields" :key="name">
                    <td>
                      <span class="text-bigger">{{ $t(name) }}</span>
                    </td>
                    <td class="text-right">
                      <span class="text-bigger number">
                        {{ value | moneyFormat }}
                        <span class="yen">{{$t("currency.japanese.yen")}}</span>
                      </span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="col-md-4 height-half" v-for="item in activeServicesHasMultiBlock" :key="item.id">
            <div class="box" v-for="balance in item.balanceBlock" :key="balance.title"
                 :style="{ display: balance.hasServiceBalance ? 'block' : 'none' }">
              <h5 class="box-title title no-border">{{ $t(balance.title) }}</h5>
              <div class="box-ct">
                <table class="table table-noborder table-striped balance-table">
                  <tbody>
                  <tr v-for="(value, name) in balance.fields" :key="name">
                    <td>
                      <span class="text-bigger">{{ $t(name) }}</span>
                    </td>
                    <td class="text-right">
                      <span class="text-bigger number">
                        {{ value | moneyFormat }}
                        <span class="yen">{{$t("currency.japanese.yen")}}</span>
                      </span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="notification section" v-if="listAmsCustomerNewsView.length != 0">
        <h4 class="box-title title">
          <span>{{ $t("dashboard.label.news") }}</span>
        </h4>
        <div class="box-ct">
          <ul class="notification-list">
            <li :class="isRead(item.readFlg)" v-for="item in listAmsCustomerNewsViewLimit" :key="item.messageId" :id="item.messageId">
              <span class="notification-item-date">{{ item.startDate | formatDate("DD-MM-YYYY hh:mm:ss", "YYYY/MM/DD")}}</span>
              <span :class="colorMessageKind(item.messageKind)">
                {{ item.messageKind | textMessageKind }}
              </span>
              <span>{{item.serviceType | textServiceTypePopup}}</span>
              <a @click="openNewsInfo(item, false)"
                 class="notification-item-title"
                 v-html="item.messageTitle"
                 style="cursor:pointer;word-break: break-word">
              </a>
            </li>
          </ul>
          <div class="box-action text-right">
            <router-link :to="{ name: 'newsList' }" class="btn btn-black">{{ $t("btn.see_more") }}</router-link>
          </div>
        </div>
      </div>
      <div class="device-support section">
        <DeviceList></DeviceList>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * @author HungNS
 */
import {createNamespacedHelpers} from "vuex";
import DeviceList from './DeviceList'
import * as TYPE from "@/store/modules/dashboard/type";
import {SET_ACTIVE_TAB_ID,MENU_HOME} from '@/store/modules/header/type';
import * as NEWS_TYPE from "@/store/modules/news/type";

const {mapState: mapDashboardState, mapGetters: mapDashboardGetters, mapActions: mapDashboardActions} = createNamespacedHelpers("dashboard");
const { mapState: mapNewsState, mapActions: mapNewsActions} = createNamespacedHelpers("news");
const { mapActions: mapHeaderAction} = createNamespacedHelpers("header");

export default {
  components: {DeviceList},
  data(){
    return {
      SERVICE_NAME: "dashboard",
      errorMessage: ""
    }
  },
  computed: {
    serverTime: () => Date.now(),
    ...mapDashboardState({
      totalEquity: (state) => state.totalEquity,
      listAmsCustomerNewsView: state => state.listAmsCustomerNewsView,
      serverTime: state => state.serverTime
    }),
    ...mapDashboardGetters([
      "activeServicesHasSigleBlock",
      "activeServicesHasMultiBlock",
    ]),

    ...mapNewsState({
      agreeNewsInfoFlg: state => state.agreeNewsInfoFlg,
      listAgreeNewsInfo: state => state.listAgreeNewsInfo
    }),

    listAmsCustomerNewsViewLimit: function () {
      return this.listAmsCustomerNewsView.slice(0, 5);
    }
  },
  created: function () {
    this[SET_ACTIVE_TAB_ID](MENU_HOME);
    if (this.agreeNewsInfoFlg) {
      let self = this;

      let callbackFunction = async (agreeMessageId) => {
        let params = {
          messageId: agreeMessageId
        };
        let response = await self.$service.getService(self.SERVICE_NAME).saveAgreementNews(params);
        if (response && response.errorMessage) {
          self.errorMessage = response.errorMessage
        }
        self.$root.$emit(self.IConstants.EVENT_NAME.ON_CONFIRM_AGREEMENT_WEBKIT);
        self[NEWS_TYPE.SET_AGREE_MENT_FLG](false);
        self[TYPE.GET_CUSTOMER_NEWS]();
      };
      this.openNews(this.listAgreeNewsInfo, true, callbackFunction);
    }
    this.fetchData();
  },
  methods: {
    ...mapHeaderAction([SET_ACTIVE_TAB_ID]),
    ...mapDashboardActions([
      TYPE.GET_BALANCE_INFO,
      TYPE.GET_CUSTOMER_NEWS,
      TYPE.GET_SERVER_TIME
    ]),
    ...mapNewsActions([NEWS_TYPE.SET_AGREE_MENT_FLG]),
    openNews: function (item, isAgreementNews, callbackFunction) {
      this.$modal.showNewsInfo(this.prepareDataToOpenNewsInfo(item, isAgreementNews, callbackFunction))
    },
    fetchData() {
      this[TYPE.GET_BALANCE_INFO]();
      this[TYPE.GET_CUSTOMER_NEWS]();
      this[TYPE.GET_SERVER_TIME]();
    },
    reloadPage() {
      this[TYPE.GET_BALANCE_INFO]();
      this[TYPE.GET_SERVER_TIME]();
    },
    openNewsInfo(item, isAgreementNews){
      let self = this;
      let callbackFunction = () => {
        let config = {
          readFlg : item.readFlg,
          messageId : item.messageId,
          messageType : item.messageType
        };
        const response = self.$service.getService(self.SERVICE_NAME).agreeNews(config);
        if(response.errorMessage){
          self.errorMessage = response.errorMessage
        } else {
          let child = document.getElementById(item.messageId);
          child.setAttribute('class', this.IConstants.MARK_AS_READ_CLASS.READ);
        }
      };
      this.openNews(item, isAgreementNews, callbackFunction);
    }
  },

};
</script>

<style>
#tooltip-maintain .tooltipbig-wrapper {
  font-weight: 400;
  margin-left: -25px;
}

.balance-table th, .table td {
  padding: 8px !important;
}

.label {
  color: white;
  padding: .2em .6em .3em;
  line-height: 1;
  border-radius: .25em;
  white-space: nowrap;
}

.device-support.section {
    margin-top: 60px;
}

@media screen and (max-width: 480px) {
    #dashboard-tooltip {
        left: 0 !important;
    }
}

@media screen and (max-width: 614px) {
    #dashboard-tooltip {
        left: 210px;
    }
}

</style>
